import React, {Component} from 'react';
import ReactTable from 'react-table';
import Select from 'react-select';
import axios from 'axios';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import {connect} from 'react-redux'
import Alert from 'react-s-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import qs from 'qs'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
//components
import PopupVerify from './PopupVerify'
import CustomAlert from '../CustomAlert'
import printDocument from '../../printDocument';
//other
import Config from '../../config'
import {setTrue} from '../../actions/refresh'

moment.tz.setDefault('Europe/Stockholm');
moment.locale('sv');
pdfMake.vfs = pdfFonts.pdfMake.vfs

class WheelsInTrunkTable extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: [],
            selected: [],
            selectedWheels: [],
            selectedOption: null,
            wheelChangers: [],
            wheelInfo: null,
            loading: false,
            showPopup: false,
            comment: '',
            shippingNo: ''
        }

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleSend = this.handleSend.bind(this)
        this.togglePopup = this.togglePopup.bind(this)
        this.prepareSend = this.prepareSend.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.getWheels = this.getWheels.bind(this)
        this.getWheelChangers = this.getWheelChangers.bind(this)
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSelectChange = (selectedOption) => {
        this.setState({selectedOption});
    }

    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    prepareSend(e) {
        var selectedWheels = []
        var selectedWheelIds = []

        this.state.data.forEach((wheel, i) => {
            if (this.state.selected.includes(i)) {
                selectedWheels.push(wheel)
                selectedWheelIds.push(wheel.id)
            }
        })

        const params = {
            FromLocationId: parseInt(Config.api.getWheelChangerId(), 10),
            ToLocationId: this.state.selectedOption.id,
            FromLocationType: 'Station',
            ToLocationType: 'Station',
            WheelIds: selectedWheelIds
        }

        if (selectedWheels.length > 0 && this.state.selectedOption !== null) {
            axios.get(Config.api.getDomain() + 'wheel/sendWheelInfo', {
                headers: Config.api.getConfig().headers,
                params: params,
                paramsSerializer: qs.stringify
            })
                .then(response => {
                    this.setState({
                        wheelInfo: response.data,
                        selectedWheels
                    })
                    this.togglePopup()
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }

    componentDidMount() {
        this.getWheels()
        this.getWheelChangers()
    }

    updateTable() {
        this.getWheels()
    }

    getWheelChangers() {
        axios.get(Config.api.getDomain() + 'crud/wheelchanger', Config.api.getConfig())
            .then(res => {
                const wheelChangers = []

                res.data.forEach(wheelchanger => {
                    const newWheelchanger = {
                        id: wheelchanger.id,
                        name: wheelchanger.name,
                        value: wheelchanger.name,
                        label: wheelchanger.name
                    }

                    wheelChangers.push(newWheelchanger)
                })

                this.setState({wheelChangers})
            })
            .catch(error => {
                console.log(error);
            })
    }

    getWheels() {
        const parameters = {
            status: 'OnStation',
            wheelChangerId: Config.api.getWheelChangerId()
        }

        this.setState({loading: true}, () => {
            axios.get(Config.api.getDomain() + 'wheel/statusAndId', Config.api.getConfig(parameters))
                .then(res => {
                    var wheels = res.data.map(wheel => {
                        const newWheel = {
                            regNo: wheel.regNo,
                            waggonNo: wheel.waggonNo,
                            carModel: wheel.carModel,
                            wheeltype: wheel.wheeltype.name,
                            offRentDate: wheel.offRentDateTime === null ? '' : moment(wheel.offRentDateTime).format('YYYY-MM-DD'),
                            lastOnRentDate: wheel.offRentDateTime === null ? '' : moment(wheel.lastOnRentDate).format('YYYY-MM-DD'),
                            id: wheel.id,
                            lastOrderId: wheel.lastOrderId
                        }

                        return newWheel
                    })

                    this.setState({
                        data: wheels,
                        loading: false
                    })
                })
                .catch(error => {
                    console.log(error);
                })
        })
    }

    // Skicka hjul
    handleSend(e) {
        e.preventDefault()

        var selectedWheelIds = []

        this.state.data.forEach((wheel, i) => {
            if (this.state.selected.includes(i)) {
                selectedWheelIds.push(wheel.id)
            }
        })

        let params = {
            fromLocationId: parseInt(Config.api.getWheelChangerId(), 10),
            toLocationId: this.state.selectedOption.id,
            wheelIds: selectedWheelIds,
            shippingNo: this.state.shippingNo,
            toLocationType: 1,
            fromLocationType: 1,
            orderComment: this.state.comment
        }

        axios.post(Config.api.getDomain() + 'wheel/send', params, Config.api.getConfig())
            .then(response => {
                this.togglePopup()

                this.setState({
                    wheelInfo: {
                        id: response.data.id
                    }
                })
                Alert.info(
                    <CustomAlert
                        info={{
                            ...this.state.wheelInfo,
                            selectedWheels: this.state.selectedWheels,
                            pdfType: "wheelChanger"
                        }}
                        print={printDocument}
                    />, {
                        timeout: 'none'
                    })

                this.updateTable()
            })
            .catch(error => {
                console.log(error)
            })
    }

    // Bekräfta vinterhjul i baklucka
    handleSubmit(e) {
        const wheels = []
        console.log(this.state.data, 'this.state.data')
        console.log(this.state.selected, 'this.state.selected')

        this.state.data.forEach((wheel, i) => {
            if (this.state.selected.includes(i)) {
                wheels.push(wheel.id);
            }
        })

        var params = {
            'wheelIds': wheels,
            'wheelChangerId': Config.api.getWheelChangerId()
        }
        
        axios.post(Config.api.getDomain() + 'returnStation/confirmWheelsInTrunk', params, Config.api.getConfig())
            .then(response => {
                this.updateTable()
                this.setState({
                    selected: []
                })
            })
            .catch(error => {
                let message = error.response.data.message
                alert('Kunde inte Skifta: ' + message)
            })
    }

    render() {
        const {selectedOption} = this.state;

        const columns = [
            {
                Header: "Regnr",
                accessor: "regNo",
            },
            {
                Header: "Bilmodell",
                accessor: "carModel",
            },
            {
                Header: "Hjulmodell",
                accessor: "wheeltype",
            },
            {
                Header: "Off rent date",
                accessor: "offRentDate",
            },
            {
                Header: "Last on rent",
                accessor: "lastOnRentDate"
            },
        ]

        return (
            <div className="confirm-orders">
                <h2>Bekräfta hjul i bakluckan</h2>
                <ReactTable
                    data={this.state.data}
                    loading={this.state.loading}
                    loadingText="Laddar..."
                    columns={columns}
                    minRows="0"
                    pageSize="200"
                    className="need-confirm-ordertable shift-table"
                    showPagination={false}
                    noDataText="Inga hjul hittades"
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            onClick: (e) => {
                                var a = this.state.selected.indexOf(rowInfo.index);

                                if (a === -1) {
                                    this.setState({
                                        selected: [...this.state.selected, rowInfo.index]
                                    });
                                }

                                var array = this.state.selected;

                                if (a !== -1) {
                                    array.splice(a, 1);
                                    this.setState({selected: array});
                                }
                            },
                            className: this.state.selected.indexOf(rowInfo.index) !== -1 ? 'selected' : null
                        }
                    }}
                />

                <button
                    onClick={this.handleSubmit}
                    className="btn yellow confirmorders"
                    name="confirm-wheels-in-trunk"
                >
                    Bekräfta vinterhjul i baklucka
                </button>

                <span className='cursive'>Eller</span>

                <Select
                    value={selectedOption}
                    onChange={this.handleSelectChange}
                    options={this.state.wheelChangers.filter(wheelchanger => {
                        return wheelchanger.id !== parseInt(Config.api.getWheelChangerId(), 10)
                    })}
                    className='select-station'
                    placeholder='SKICKA TILL...'
                />

                <button
                    onClick={this.prepareSend}
                    className="send btn yellow"
                    name="send-to-station"
                    disabled={!selectedOption}
                >
                    Skicka
                </button>

                {
                    this.state.showPopup ?
                        <PopupVerify
                            data={this.state.selectedWheels}
                            wheelInfo={this.state.wheelInfo}
                            toggleNext={this.toggleNext}
                            closePopup={this.togglePopup.bind(this)}
                            submit={this.handleSend}
                            onChange={this.handleChange}
                        /> : null
                }
            </div>
        )
    }
}


/**
 * Map state to properties
 */
const mapStateToProps = (state) => {
    return {
        refresh: state.refresh
    };
};

/**
 * Map actions to properties
 */
const mapDispatchToProps = (dispatch) => {
    return {
        setTrue: (key) => dispatch(setTrue(key))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WheelsInTrunkTable)


// WEBPACK FOOTER //
// ./src/components/Stock/WheelsInTrunkTable.js